import React from 'react';
import {contentTexts} from "../ContentText";
import Box from "@mui/material/Box";
import DigitalHubImage from "../../Images/DigitalHub.png"
import DigitalHubMobileImage from "../../Images/DigitalHubMobile.png"
import GooglePlay from "../../Images/GooglePlay.png"
import AppStore from "../../Images/AppStore.png"
import "./DigitalHub.css"
import TopTitle from "../Components/TopTitle";
import SubTitle from "../Components/SubTitle";
import {defaultColors} from "../ColorSchema";
import {useMediaQuery, useTheme} from "@mui/material";

function DigitalHub(props) {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    return (
        <Box className="customer_content" ref={props.refs} >

            <TopTitle sx={{color: defaultColors.surface_container_highest}}>{contentTexts.digitalHubTitle}</TopTitle>
            <SubTitle sx={{color: defaultColors.surface_container_highest}}>{contentTexts.digitalHubSubtitle}</SubTitle>
            <img style={{
                paddingTop: "16px",
                width: "100%",
            }} src={!isMobile ?DigitalHubImage: DigitalHubMobileImage } alt={"DigitalHub"}/>
            <Box
                style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "24px",
                    paddingTop: "16px"
                }}
            >
                <a href={"https://play.google.com/store/apps/details?id=com.smartphysique.app&pcampaignid=web_share"}
                   aria-label="GooglePlay Link">

                <img
                    src={GooglePlay}
                    alt={"GooglePlay Icon"}
                    style={{
                        width: isMobile ? "85%" : "34%",
                        float:"inline-end"

                    }}
                /></a>
                <a href={"https://apps.apple.com/at/app/smart-physique/id6739454700 "} aria-label="AppStore Link">

                <img
                    src={AppStore}
                    alt={"AppStore iOS Icon"}

                    style={{
                        width: isMobile ? "85%" : "34%",
                    }}
                /></a>
            </Box>
        </Box>
    );
}

export default DigitalHub;